"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _withMapping = _interopRequireDefault(require("../../../Context/withMapping"));

var _WysiwygField = _interopRequireDefault(require("../../WysiwygField"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var GenericFormElement = function GenericFormElement(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var className = props.className,
      title = props.title,
      required = props.required,
      description = props.description,
      fieldName = props.fieldName,
      touched = props.touched,
      error = props.error,
      children = props.children,
      displayRequiredIndicator = props.displayRequiredIndicator;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: error ? "FormElement ".concat(className, " error") : "FormElement ".concat(className)
  }, title && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: fieldName
  }, title, !required && displayRequiredIndicator === 'optional' && /*#__PURE__*/_react.default.createElement("span", {
    className: "FormElement__optional ".concat(className, "__optional")
  }, t(['form.optional', ' - optioneel'])), required && displayRequiredIndicator === 'required' && /*#__PURE__*/_react.default.createElement("span", {
    className: "FormElement__required ".concat(className, "__required")
  }, t(['form.required', ' - vereist']))), /*#__PURE__*/_react.default.createElement("div", {
    className: "FormElement__inner ".concat(className, "__inner")
  }, children), description && /*#__PURE__*/_react.default.createElement(_WysiwygField.default, {
    property: "schema:text",
    html: description,
    className: "FormElement__description ".concat(className, "__description")
  }), error && touched ? /*#__PURE__*/_react.default.createElement("div", {
    className: "FormElement__error ".concat(className, "__error")
  }, error) : null);
};

var _default = (0, _withMapping.default)(GenericFormElement);

exports.default = _default;